export function getProjectViewName(locale) {
  switch (locale) {
    case "pl":
      return "projekt";
    case "en":
    default:
      return "project";
  }
}
